import {
  Dropdown,
  Textarea,
  MultiplayCheckBoxSelection,
  MultiSelectDropdown,
} from "../../components";
import Icons from "../../assets/icon";
import Functions from "./index.function";
const ProfessionalPreferences = ({
  register,
  errors,
  setValue,
  control,
  select,
  setSelect,
  otherExperienceId,
  otherLanguageId,
}) => {
  const {
    desiredJobType,
    isLoadingMaincategory,
    dropdowns,
    isLoading,
    handleDropdwonSelect,
  } = Functions(setSelect);

  return (
    <div className={"flex flex-col xs:w-full sm:w-[90%] lg:w-[60%] mx-auto"}>
      <div className="w-full xs:mb-1.5 sm:mb-2 lg:mb-2">
        <Textarea
          lable={"Comments / Qualifications"}
          name={"qualification"}
          register={register}
          isMandatory={true}
          setValue={setValue}
          errors={errors}
        />
      </div>
      <div className="xs:mb-1.5 sm:mb-2 lg:mb-2 xs:pt-1 lg:pt-1">
        <MultiSelectDropdown
          control={control}
          errors={errors}
          rightIcon={Icons.arrowIcon}
          isMandatory={true}
          label={"Desired Job"}
          // options={desiredJobType?.categories}
          options={desiredJobType}
          valueName="title"
          valueoption="id"
          name={"desiredJobType"}
          isLoadingpreFiled={isLoadingMaincategory}
          isLoading={isLoadingMaincategory}
        />
      </div>
      <div className="w-full">
        <Dropdown
          control={control}
          rightIcon={Icons.arrowIcon}
          label={"Experience level"}
          options={dropdowns?.experience}
          valueName="job_experience"
          valueoption="job_experience_id"
          name={"experience"}
          isMandatory={true}
          selectedValue={select.experienceLevel}
          handleSelect={(value) =>
            handleDropdwonSelect("experienceLevel", value)
          }
          errors={errors}
          isLoading={isLoading}
        />
      </div>
      {otherExperienceId == 52 && (
        <div className="w-full xs:!mb-[2px] sm:mb-1">
          <Textarea
            lable={"Other Experience"}
            name={"otherExperience"}
            register={register}
            isMandatory={true}
            setValue={setValue}
            errors={errors}
          />
        </div>
      )}
      <div className="xs:mb-1.5 xs:pl-6 sm:mb-2 sm:pl-6 lg:mb-2 lg:pl-8 xs:pt-1 lg:pt-1">
        <MultiplayCheckBoxSelection
          control={control}
          name="languagesSpoken"
          items={"lang"}
          mapitems={dropdowns?.languages}
          register={register}
          isMandatory={true}
          isRequired={true}
          errors={errors}
          label="Languages Spoken"
        />
      </div>
      {(Array.isArray(otherLanguageId)
        ? otherLanguageId.includes(195)
        : otherLanguageId == 195) && (
        <div className="w-full xs:!mb-[2px] sm:mb-1">
          <Textarea
            lable={"Other Language"}
            name={"otherLanguage"}
            register={register}
            isMandatory={true}
            setValue={setValue}
            errors={errors}
          />
        </div>
      )}

      {/* <div className="w-full">
                <Dropdown
                    control={control}
                    rightIcon={Icons.arrowIcon}
                    label={'Sexual Orientation'}
                    options={dropdowns?.sexualOrientation}
                    name={"sexualOrientations"}
                    valueName='name'
                    valueoption='sexual_orientation_id'
                      isMandatory={true}
                    selectedValue={select.sexualOrientation}
                    handleSelect={(value) => handleDropdwonSelect("sexualOrientation", value)}
                    errors={errors}
                    isLoading={isLoading}
                />
            </div> */}
    </div>
  );
};

export default ProfessionalPreferences;
